// import React, { useState } from "react";
// import { Button, List, ListItem, ListItemText } from "@mui/material";
// import Coc from "./Coc"; // Chat page
// import styles from "./Dashboard.module.css";

// // Import logo paths
// import OutlookLogo from "../../../../asset/dashb/outlook_icon.png";
// import GmailLogo from "../../../../asset/dashb/gmail_icon.png"
// import CalendarLogo from "../../../../asset/dashb/gcalendar_icon.png";

// const Dashboard = () => {
//   const [selectedBot, setSelectedBot] = useState(null);
//   const [showChatPage, setShowChatPage] = useState(false);
//   const bots = ["Code of Conduct"]; 

//   const handleSelectBot = (bot) => {
//     setSelectedBot(bot);
//     setShowChatPage(false); 
//   };

//   const handleCreateBot = () => {
//     if (selectedBot) {
//       setShowChatPage(true);
//     } else {
//       alert("Please select a bot first.");
//     }
//   };

//   return (
//     <div className={styles.dashboard}>
//       {/* Left Sidebar */}
//       <div className={styles.sidebar}>
//         <div className={styles.sidebarHeader}>
//           <span className={styles.botName}>Mebot</span>
//         </div>

//         {/* List of Bots */}
//         <List className={styles.botList}>
//           {bots.map((bot, index) => (
//             <ListItem
//               button
//               key={index}
//               selected={selectedBot === bot} // Highlight selected bot
//               onClick={() => handleSelectBot(bot)}
//               className={`${styles.botListItem} ${
//                 selectedBot === bot ? styles.selectedBot : ""
//               }`}
//             >
//               <ListItemText primary={bot} />
//             </ListItem>
//           ))}
//         </List>

//         {/* Create Bot Button */}
//         <Button
//           variant="contained"
//           color="inherit"
//           className={styles.createBotButton}
//           onClick={handleCreateBot}
//           disabled={!selectedBot} // Disable button until a bot is selected
//         >
//           Create Bot
//         </Button>
//       </div>

//       {/* Main Content */}
//       <div className={styles.mainContent}>
//         {showChatPage ? (
//           <div className={styles.chatPageWrapper}>
//             {/* Top Bar with Icons */}
//             <div className={styles.topBar}>
//               <img
//                 src={OutlookLogo}
//                 alt="Outlook"
//                 className={styles.icon}
//                 title="Outlook"
//               />
//               {/* <img
//                 src={GmailLogo}
//                 alt="Gmail"
//                 className={styles.icon}
//                 title="Gmail"
//               /> */}
//               <img
//                 src={CalendarLogo}
//                 alt="Calendar"
//                 className={styles.icon}
//                 title="Calendar"
//               />
//             </div>

//             {/* Chat Page */}
//             <Coc botName={selectedBot} />
//           </div>
//         ) : (
//           <div className={styles.placeholder}>
//             <h2>Welcome to the Dashboard</h2>
//             <p>Select a bot from the list and click "Create Bot" to get started.</p>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Dashboard;

// import React, { useState } from "react";
// import { Button, List, ListItem, ListItemText } from "@mui/material";
// import Coc from "./Coc"; // Chat page
// import styles from "./Cocdashboard.module.css";

// // Import logo paths
// import OutlookLogo from "../../../../asset/dashb/outlook_icon.png";
// import CalendarLogo from "../../../../asset/dashb/gcalendar_icon.png";

// const Dashboard = () => {
//   const [selectedBot, setSelectedBot] = useState(null);
//   const [showChatPage, setShowChatPage] = useState(false);
//   const [chatContent, setChatContent] = useState(""); // State for chat content
//   const bots = ["Code of Conduct"];

//   const handleSelectBot = (bot) => {
//     setSelectedBot(bot);
//     setShowChatPage(false);
//   };

//   const handleCreateBot = () => {
//     if (selectedBot) {
//       setShowChatPage(true);
//     } else {
//       alert("Please select a bot first.");
//     }
//   };

//   // Function to handle calendar icon click
//   const handleCalendarClick = () => {
//     window.open("https://calendar.google.com", "_blank");
//   };

//   // Function to handle Outlook click
//   const handleOutlookClick = () => {
//     if (!chatContent) {
//       alert("No chat content to send.");
//       return;
//     }
//     const mailtoLink = `mailto:?subject=${encodeURIComponent(
//       "Code of Conduct Response"
//     )}&body=${encodeURIComponent(chatContent)}`;
//     window.open(mailtoLink, "_blank"); // Open the mailto link in a new tab
//   };

//   return (
//     <div className={styles.dashboard}>
//       {/* Left Sidebar */}
//       <div className={styles.sidebar}>
//         <div className={styles.sidebarHeader}>
//           <span className={styles.botName}>Mebot</span>
//         </div>

//         {/* List of Bots */}
//         <List className={styles.botList}>
//           {bots.map((bot, index) => (
//             <ListItem
//               button
//               key={index}
//               selected={selectedBot === bot}
//               onClick={() => handleSelectBot(bot)}
//               className={`${styles.botListItem} ${
//                 selectedBot === bot ? styles.selectedBot : ""
//               }`}
//             >
//               <ListItemText primary={bot} />
//             </ListItem>
//           ))}
//         </List>

//         {/* Create Bot Button */}
//         <Button
//           variant="contained"
//           color="inherit"
//           className={styles.createBotButton}
//           onClick={handleCreateBot}
//           disabled={!selectedBot}
//         >
//           Create Bot
//         </Button>
//       </div>

//       {/* Main Content */}
//       <div className={styles.mainContent}>
//         {showChatPage ? (
//           <div className={styles.chatPageWrapper}>
//             {/* Top Bar with Icons */}
//             <div className={styles.topBar}>
//               <img
//                 src={OutlookLogo}
//                 alt="Outlook"
//                 className={styles.icon}
//                 title="Outlook"
//                 onClick={handleOutlookClick}
//                 style={{ cursor: "pointer" }}
//               />
//               <img
//                 src={CalendarLogo}
//                 alt="Calendar"
//                 className={styles.icon}
//                 title="Calendar"
//                 onClick={handleCalendarClick}
//                 style={{ cursor: "pointer" }}
//               />
//             </div>

//             {/* Chat Page */}
//             <Coc
//               botName={selectedBot}
//               setChatContent={setChatContent} // Pass setChatContent to Coc
//             />
//           </div>
//         ) : (
//           <div className={styles.placeholder}>
//             <h2>Welcome to the Dashboard</h2>
//             <p>Select a bot from the list and click "Create Bot" to get started.</p>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Dashboard;

//gmail function

import React, { useState } from "react";
import { Button, List, ListItem, ListItemText } from "@mui/material";
import Coc from "./Coc";
import FileUpload from "./Fileupload.js";
import styles from "./Cocdashboard.module.css";

// Import logo paths
// import OutlookLogo from "../../../../asset/dashb/outlook_icon.png";
import CalendarLogo from "../../../../asset/dashb/gcalendar_icon.png";
import MailLogo from "../../../../asset/dashb/mail_icon.png";
import CalendarrLogo from "../../../../asset/dashb/calendar_icon.png"


const Dashboard = () => {
  const [selectedBot, setSelectedBot] = useState(null);
  const [showChatPage, setShowChatPage] = useState(false);
  const [chatContent, setChatContent] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [recipient, setRecipient] = useState("");
  const [subject, setSubject] = useState("Code of Conduct Response");
  const [fileUploaded, setFileUploaded] = useState(false);
  const [showFileUpload, setShowFileUpload] = useState(false);
  const [emailStatus, setEmailStatus] = useState({ success: null, message: "" });
  // const [uploadError, setUploadError] = useState(null);

  const bots = ["Code of Conduct"];

  const handleSelectBot = (bot) => {
    setSelectedBot(bot);
    setShowChatPage(false);
  };

  const handleCreateBot = () => {
    if (selectedBot && fileUploaded) {
      setShowChatPage(true);
    } else {
      alert("Please select a bot and upload a file first.");
    }
  };

  // const handleOutlookClick = () => {
  //   if (!chatContent) {
  //     alert("No chat content to send.");
  //     return;
  //   }
  //   setShowPopup(true); // Show the popup
  // };

  const handleGmailClick = () => {
    if (!chatContent) {
      alert("No chat content to send.");
      return;
    }
    setShowPopup(true); // Show the popup
  };

  const handleClosePopup = () => {
    setShowPopup(false); // Hide the popup
    setEmailStatus({ success: null, message: "" });
  };

  // const handleSendEmail = () => {
  //   if (!recipient.trim()) {
  //     alert("Please enter a recipient email.");
  //     return;
  //   }
  //   const mailtoLink = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(
  //     recipient
  //   )}&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(chatContent)}`;
  //   window.open(mailtoLink, "_blank");
  //   setShowPopup(false);
  // };

  const handleSendEmail = async () => {
    if (!recipient.trim()) {
      // alert("Please enter a recipient email.");
      setEmailStatus({ success: false, message: "Please enter a recipient email." });
      return;
    }

    try {
      const response = await fetch("http://localhost:5000/send-email", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          recipient,
          subject,
          message: chatContent,
        }),
      });

      if (response.ok) {
        setEmailStatus({ success: true, message: "Email sent successfully!" });
      } else {
        const errorMessage = await response.text();
        setEmailStatus({ success: false, message: `Failed to send email: ${errorMessage}` });
      }
    } catch (error) {
      console.error("Error sending email:", error);
      setEmailStatus({ success: false, message: "An error occurred. Please try again." });
    }
  };


  const handleCalendarClick = () => {
    window.open("https://calendar.google.com", "_blank");
  };

  const handleFileUploadSuccess = () => {
    setFileUploaded(true);
    setShowFileUpload(false);
  };

  const handleFileUploadClick = () => {
    setShowFileUpload(true); // Show the FileUpload component
  };

  return (
    <div className={styles.dashboard}>
      {/* Left Sidebar */}
      <div className={styles.sidebar}>
        <div className={styles.sidebarHeader}>
          <span className={styles.botName}>Mebot</span>
        </div>

        {/* List of Bots */}
        <List className={styles.botList}>
          {bots.map((bot, index) => (
            <ListItem
              button
              key={index}
              selected={selectedBot === bot}
              onClick={() => handleSelectBot(bot)}
              className={`${styles.botListItem} ${selectedBot === bot ? styles.selectedBot : ""
                }`}
            >
              <ListItemText primary={bot} />
            </ListItem>
          ))}
        </List>

        {/* File Upload Button */}
        <Button
          variant="contained"
          color="inherit"
          className={styles.uploadFileButton}
          onClick={handleFileUploadClick}
          disabled={!selectedBot || fileUploaded}
        >
          Upload File
        </Button>

        {/* Create Bot Button */}
        <Button
          variant="contained"
          color="inherit"
          className={styles.createBotButton}
          onClick={handleCreateBot}
          disabled={!selectedBot || !fileUploaded}
        >
          Create Bot
        </Button>
      </div>

      {/* Main Content */}
      <div className={styles.mainContent}>
        {showChatPage ? (
          <div className={styles.chatPageWrapper}>
            {/* Top Bar with Icons */}
            <div className={styles.topBar}>
              {/* <img
                src={OutlookLogo}
                alt="Outlook"
                className={styles.icon}
                title="Outlook"
                onClick={handleOutlookClick}
                style={{ cursor: "pointer" }}
              /> */}
              <img
                src={MailLogo}
                alt="Gmail"
                className={styles.icon}
                title="Gmail"
                onClick={handleGmailClick}
                style={{ cursor: "pointer" }}
              />
              <img
                src={CalendarrLogo}
                alt="Calendar"
                className={styles.icon}
                title="Calendar"
                onClick={handleCalendarClick}
                style={{ cursor: "pointer" }}
              />
            </div>

            {/* Chat Page */}
            <Coc
              botName={selectedBot}
              setChatContent={setChatContent} // Pass setChatContent to Coc
            />
          </div>
        ) : showFileUpload ? (
          <FileUpload onUploadComplete={handleFileUploadSuccess} />
        ) : (
          <div className={styles.placeholder}>
            <h2>Compliance AI Officer</h2>
            <p>
              {fileUploaded
                ? "File uploaded successfully! Now click 'Create Bot' to get started."
                : "Select a bot from the list and click 'Upload File' to get started."}
            </p>
          </div>
        )}
      </div>

      {/* Popup for Email */}
      {showPopup && (
        <div className={styles.popupOverlay}>
          <div className={styles.popup}>
            <button className={styles.closeButton} onClick={handleClosePopup}>
              &times;
            </button>
            <h3>Response Mail</h3>
            <div className={styles.formGroup}>
              <label>Recipient:</label>
              <input
                type="email"
                value={recipient}
                onChange={(e) => setRecipient(e.target.value)}
                placeholder="Enter recipient email"
              />
            </div>
            <div className={styles.formGroup}>
              <label>Subject:</label>
              <input
                type="text"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
              />
            </div>
            <div className={styles.formGroup}>
              <label>Message:</label>
              <textarea
                value={chatContent}
                readOnly
                className={styles.readOnlyMessage}
              ></textarea>
            </div>
            <Button
              className={styles.sendButton}
              variant="contained"
              color="inherit"
              onClick={handleSendEmail}
            >
              Send
            </Button>
            {emailStatus.message && (
              <div
                className={`${styles.statusMessage} ${emailStatus.success ? styles.success : styles.error
                  }`}
              >
                {emailStatus.message}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
